"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gatsby = require("gatsby");

var _useBreadcrumb2 = _interopRequireDefault(require("./useBreadcrumb"));

var _jsxFileName = "/home/circleci/repo/src/components/Breadcrumb.js";

var Breadcrumb = function Breadcrumb(_ref) {
  var title = _ref.title,
      location = _ref.location,
      crumbLabel = _ref.crumbLabel,
      crumbSeparator = _ref.crumbSeparator,
      crumbWrapperStyle = _ref.crumbWrapperStyle,
      crumbActiveStyle = _ref.crumbActiveStyle,
      crumbStyle = _ref.crumbStyle,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["title", "location", "crumbLabel", "crumbSeparator", "crumbWrapperStyle", "crumbActiveStyle", "crumbStyle"]);

  // TODO: if 'setHome' === true, set default Home crumb using first set of params
  var _useBreadcrumb = (0, _useBreadcrumb2.default)({
    location: location,
    crumbLabel: crumbLabel,
    crumbSeparator: crumbSeparator,
    crumbStyle: crumbStyle,
    crumbActiveStyle: crumbActiveStyle
  }),
      _useBreadcrumb$crumbs = _useBreadcrumb.crumbs,
      crumbs = _useBreadcrumb$crumbs === void 0 ? [] : _useBreadcrumb$crumbs;

  return _react.default.createElement("div", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 30
    },
    __self: this
  }, _react.default.createElement("span", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31
    },
    __self: this
  }, title), crumbs.map(function (c, i) {
    return _react.default.createElement("div", (0, _extends2.default)({
      style: {
        display: 'inline'
      },
      key: i
    }, crumbWrapperStyle, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 34
      },
      __self: this
    }), _react.default.createElement(_gatsby.Link, (0, _extends2.default)({
      to: c.pathname || '',
      style: (0, _extends2.default)({
        textDecoration: 'none',
        fontSize: '16pt',
        color: '#e1e1e1'
      }, c.crumbStyle),
      activeStyle: (0, _extends2.default)({
        color: 'white'
      }, crumbActiveStyle),
      state: {
        crumbClicked: true
      }
    }, rest, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35
      },
      __self: this
    }), c.crumbLabel), _react.default.createElement("span", {
      style: (0, _extends2.default)({
        fontSize: '16pt'
      }, c.crumbStyle),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54
      },
      __self: this
    }, c.crumbSeparator));
  }));
};

Breadcrumb.defaultProps = {
  title: '',
  crumbSeparator: ' / ',
  crumbWrapperStyle: {},
  crumbStyle: {},
  crumbActiveStyle: {}
};
Breadcrumb.propTypes = {
  location: _propTypes.default.shape().isRequired,
  crumbLabel: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  crumbSeparator: _propTypes.default.string,
  crumbWrapperStyle: _propTypes.default.shape(),
  crumbActiveStyle: _propTypes.default.shape(),
  crumbStyle: _propTypes.default.shape()
};
var _default = Breadcrumb;
exports.default = _default;